<template>
  <div :class="['map-marker']" :style="styles">
    <svg :class="[`svg-arrow-${arrowPosition}`]" width="22" height="32" xmlns="http://www.w3.org/2000/svg" clip-rule="evenodd">
      <g id="svg_1" transform="matrix(0.3744628601851496,0,0,0.4343219134874682,-29.861531570418506,-20.649328450181862) ">
        <path id="svg_2" :fill="color" fill-rule="nonzero" d="m135.769267,121.127644l-54.279,0l27.203,-72.037l27.076,72.037z"/>
      </g>
    </svg>
    <div :class="['name', {'lonely': !distance}]">{{name}}</div>
    <div v-if="distance" class="time">{{distance}}</div>
    <div v-if="direction" class="direction">{{direction}}</div>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    },
    number: {
      type: String
    },
    arrowPosition: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    direction: {
      type: String
    },
    distance: {
      type: String
    },
    top: {
      type: String,
      required: true
    },
    left: {
      type: String,
      required: true
    }
  },
  data () {
    return { }
  },
  computed: {
    position () {
      return `top: ${this.top}px; left: ${this.left}px;`
    },
    bgColor () {
      return `background-color: ${this.color};`
    },
    borderColor () {
      return `border-color: ${this.color}`
    },
    styles () {
      return `${this.position} ${this.bgColor}`
    }
  }
}
</script>

<style lang="scss">
  .map-marker {
      font-family: 'Paytone One', sans-serif;
      font-size: 3rem;
      font-weight: 400;
      letter-spacing: 3px;
      line-height: 1;
      position: absolute;
      padding: 8px 15px;
      border-radius: 9px;

      .time {
        display: inline-block;
        background-image: url(./../../assets/walk.svg);
        line-height: 36px;
        text-indent: 30px;
        font-family: 'ABeeZee', sans-serif;
        font-size: 1.5rem;
        letter-spacing: 0;
      }

      .direction {
        display: inline-block;
        font-size: 0.8em;
        margin-left: 20px;
        line-height: 36px;
        font-family: 'ABeeZee', sans-serif;
        font-size: 1.5rem;
        letter-spacing: 0;
      }

      .name {
        &.lonely {
          font-size: 2rem;
          margin-bottom: 10px;
        }
      }

      .svg-arrow-left {
        position: absolute;
        left: -25px;
        top: 15px;
        transform: rotate(-90deg);
      }
      .svg-arrow-right {
        position: absolute;
        right: -25px;
        top: 15px;
        transform: rotate(90deg);
      }
      .svg-arrow-top {
        position: absolute;
        right: 34px;
        top: -30px;
      }
      .svg-arrow-down {
        position: absolute;
        right: 34px;
        bottom: -16px;
        transform: rotate(180deg);
      }
    }
</style>
